import { useTranslation } from 'react-i18next';

import { DatePickerField } from 'fields';
import { useField } from 'formik';

export default function DeliveryStartDate() {
  const { t } = useTranslation('CreateOrder');
  const [{ value: transportMethod }] = useField('transportMethod');

  return (
    <DatePickerField
      required
      disablePast
      name="startDate"
      label={t(`ProductForm.labels.startDate${transportMethod}`)}
    />
  );
}
